import { Theme } from '@mui/material'
import { EmsBatteryMode, EmsSgReadyMode } from '../dynamic-power-prices/types'
import { UnitTypes } from '../types'
import { AI360BatteryStatusBadge, AI360ChartDataKeyType, AI360SgReadyStatusBadge } from './types'

export const getSgReadyStatusBadges = (theme: Theme): AI360SgReadyStatusBadge[] => [
  {
    status: EmsSgReadyMode.Normal,
    color: theme.palette.sgReadyModes[EmsSgReadyMode.Normal].backgroundColor,
    textColor: theme.palette.sgReadyModes[EmsSgReadyMode.Normal].color,
    label: 'ai360.sg-ready-status.normal-operation',
  },
  {
    status: EmsSgReadyMode.Recommended,
    color: theme.palette.sgReadyModes[EmsSgReadyMode.Recommended].backgroundColor,
    textColor: theme.palette.sgReadyModes[EmsSgReadyMode.Recommended].color,
    label: 'ai360.sg-ready-status.start-up-recommendation',
  },
  {
    status: EmsSgReadyMode.Forced,
    color: theme.palette.sgReadyModes[EmsSgReadyMode.Forced].backgroundColor,
    textColor: theme.palette.sgReadyModes[EmsSgReadyMode.Forced].color,
    label: 'ai360.sg-ready-status.start-up-command',
  },
  {
    status: EmsSgReadyMode.Blocked,
    color: theme.palette.sgReadyModes[EmsSgReadyMode.Blocked].backgroundColor,
    textColor: theme.palette.sgReadyModes[EmsSgReadyMode.Blocked].color,
    label: 'ai360.sg-ready-status.blocked',
  },
]

export const BATTERY_STATUS_BADGES: AI360BatteryStatusBadge[] = [
  {
    status: EmsBatteryMode.NormalOperation,
    color: '#C9EBC1',
    textColor: '#408830',
    label: 'ai360.battery-status.normal-operation',
  },
  {
    status: EmsBatteryMode.PvChargingDelayed,
    color: '#EBDA2F80',
    textColor: '#A6820E',
    label: 'ai360.battery-status.pv-charging-delayed',
  },
  {
    status: EmsBatteryMode.PvChargingReduced,
    color: '#E6A64C80',
    textColor: '#9A7033',
    label: 'ai360.battery-status.pv-charging-reduced',
  },
  {
    status: EmsBatteryMode.BlockDischarging,
    color: '#C191B980',
    textColor: '#832474',
    label: 'ai360.battery-status.battery-discharging-blocked',
  },
  {
    status: EmsBatteryMode.GridCharge,
    color: '#0DB2C74D',
    textColor: '#0A91A2',
    label: 'ai360.battery-status.battery-charging-from-grid',
  },
]

export const AI360_ROUTE = 'dashboard/ai360'
export const AI360_DETAILS_PAGE_ROUTE = 'details'
/** Comma separated list of weekdays in which the price should be used 0 = Monday ... */
export const WEEKDAYS_POWER_SELL_PRICE = '0,1,2,3,4,5,6'

interface AI360LineCharConfig {
  dataKey: AI360ChartDataKeyType
  color?: string
  label: string
  unit: UnitTypes
}

export const AI360_LINE_CHART_CONFIG: Record<'powerPrice' | 'solarProduction' | 'solarForecast' | 'feedInPrice', AI360LineCharConfig> = {
  powerPrice: {
    dataKey: 'powerPrice',
    color: '#88ADA4',
    label: 'ai360.line-chart.legend.electricity-price',
    unit: UnitTypes.centsPerKiloWattHour,
  },
  solarProduction: {
    dataKey: 'solarProduction',
    color: '#EBDA2F',
    label: 'ai360.line-chart.legend.pv-production',
    unit: UnitTypes.watt,
  },

  solarForecast: {
    dataKey: 'solarForecast',
    color: '#EBDA2F',
    label: 'ai360.line-chart.legend.pv-forecast',
    unit: UnitTypes.watt,
  },
  feedInPrice: {
    dataKey: 'feedInPrice',
    color: '#FFCCBC;',
    label: 'ai360.line-chart.legend.feed-in-price',
    unit: UnitTypes.centsPerKiloWattHour,
  },
}
